var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddPictures = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  style: {
    background: "#14202c"
  },
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.792 14.032q0-.864.432-1.62t1.164-1.188a3.1 3.1 0 0 1 1.596-.432q.864 0 1.608.444a3.4 3.4 0 0 1 1.188 1.188q.444.744.444 1.608t-.432 1.596a3.2 3.2 0 0 1-1.188 1.164 3.2 3.2 0 0 1-1.62.432 3.1 3.1 0 0 1-1.596-.432 3.25 3.25 0 0 1-1.164-1.164 3.1 3.1 0 0 1-.432-1.596M12.984 19q1.368 0 2.52-.66a4.9 4.9 0 0 0 1.824-1.812A4.9 4.9 0 0 0 18 14.02a4.9 4.9 0 0 0-.672-2.508 5 5 0 0 0-1.824-1.824 4.9 4.9 0 0 0-2.508-.672 4.9 4.9 0 0 0-2.508.672 4.9 4.9 0 0 0-1.812 1.824 5 5 0 0 0-.66 2.52q0 1.368.66 2.508t1.8 1.8 2.508.66M6 10V7h3V4h6.984l1.824 2.016H21q.816 0 1.416.6t.6 1.416v12q0 .816-.6 1.392T21 22H5.016a1.98 1.98 0 0 1-1.416-.576 1.86 1.86 0 0 1-.6-1.392V10zM3 4V1h2.016v3h3v2.016h-3v3H3v-3H0V4z"
})));
export default SvgAddPictures;